import request from '@/utils/request'
const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {},
	sign: 'dafdsf'
}
// 获取小程序登录方式配置
export function getLoginTypes (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custCasual/queryLoginTypes',
		method: 'post',
		data: obj
	})
}
// 设备初始化
export function initDevice (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/face/initDevice',
		method: 'post',
		data: obj
	})
}
// 同步人员信息
export function resetPerson (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/face/resetPerson?deviceId=${data.deviceId}`,
		method: 'post',
		data: obj
	})
}
// 禁用取餐柜柜门
export function disableDoor (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/macmealscounter/disable',
		method: 'put',
		data: obj
	})
}
// 获取设备开启状态
export function getChupinState (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/tcp/v1/machine/state',
		method: 'post',
		data: obj
	})
}
// 获取所有banner图标
export function getappletset (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/deskcontrol/getDeskControlPage',
		method: 'get',
		params: obj
	})
}
// 插入banner和图标
export function insertappletset (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/deskcontrol/postDeskControl',
		method: 'post',
		data: obj
	})
}

// 更新banner和图标
export function updateappletset (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/deskcontrol/updateById',
		method: 'put',
		data: obj
	})
}

// 删除banner和图标
export function deleteappletset (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/deskcontrol/removeById',
		method: 'delete',
		data: obj
	})
}

// 获取小程序设置
export function getSourceControl (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/sourcecontrol/getSourceControl',
		method: 'get',
		params: obj
	})
}

// 更新小程序设置
export function putSourceControl (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/sourcecontrol/putSourceControl',
		method: 'put',
		data: obj
	})
}

// 新增范围
export function addEffective (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkteffective/add',
		method: 'post',
		data: obj
	})
}

// 删除范围
export function delEffective (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/mkteffective/remove/${data.effId}`,
		method: 'delete',
		data: obj
	})
}

// 修改范围
export function editEffective (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkteffective/edit',
		method: 'put',
		data: obj
	})
}

// 查询范围列表
export function getEffective (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkteffective/page',
		method: 'get',
		params: obj
	})
}

// 查询就餐规则范围列表
export function mktdiningeffective (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktdiningeffective/page',
		method: 'get',
		params: obj
	})
}
// 修改就餐规则
export function updateMktdiningeffective (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktdiningeffective/edit',
		method: 'put',
		data: obj
	})
}

// 新增就餐规则范围列表
export function addMktdiningeffective (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktdiningeffective/add',
		method: 'post',
		data: obj
	})
}
// 删除节假日
export function delHoliday (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktholiday/delete',
		method: 'delete',
		data: obj
	})
}
// 新增节假日
export function addHoliday (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktholiday/add',
		method: 'post',
		data: obj
	})
}
// 分页获取节假日
export function getHoliday (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktholiday/page',
		method: 'get',
		params: obj
	})
}
// 同步当年法定节假日
export function syncHoliday (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktholiday/holiday',
		method: 'get',
		params: obj
	})
}
// 查询角色列表
export function getmgrrole (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrrole/page',
		method: 'get',
		params: obj
	})
}
// 新增角色
export function addmgrrole (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrrole/add',
		method: 'post',
		data: obj
	})
}
// 编辑角色
export function editemgrrole (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrrole/edit',
		method: 'put',
		data: obj
	})
}

// 删除角色
export function deletemgrrole (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrrole/remove/' + data,
		method: 'DELETE',
		data: obj
	})
}
// 获取角色详情
export const getRoleDetail = data => {
	return request({
		url: '/api/v1/mgrrole/edit/detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取角色标识
export function coderole (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrrole/all/role/code',
		method: 'get',
		params: obj
	})
}

// 获取所有菜单权限
export function getadminlist (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrmenu/tree',
		method: 'get',
		params: obj
	})
}

// 查询操作员列表 - 老接口
export function getmgrmgruserOld (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/page',
		method: 'get',
		params: obj
	})
}
// 查询操作员列表 - 老接口
export function getmgrmgruser (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/page-other',
		method: 'get',
		params: obj
	})
}

// 分组获取所有角色
export function getRolesByGroup (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrrole/list/by/type',
		method: 'post',
		data: obj
	})
}
export function addmgrmgruser (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/add',
		method: 'post',
		data: obj,
		encryption: ['password', 'phone']
	})
}

// 修改指定操作员登录密码
export function changepassword (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	console.log(data)
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/change/password',
		method: 'put',
		data: obj,
		encryption: ['password', 'username']
	})
}

// 编辑角色
export function editemgruser (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/edit',
		method: 'put',
		data: obj,
		encryption: ['phone']
	})
}

// 删除角色
export function deletemgruser (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/remove/' + data,
		method: 'DELETE',
		data: obj
	})
}
// 切换用户默认角色
export const changeDefaultRole = roleCode => {
	return request({
		url: '/api/v1/mgruser/change/role',
		method: 'post',
		data: { ...dataObj, content: roleCode || {} }
	})
}
// 获取所有设备
export function getshebeiAll (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mac/meal/line/mac/available',
		method: 'get',
		params: obj
	})
}
// 删除餐线下设备
export function delMealshebei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mac/meal/line/remove/mac',
		method: 'DELETE',
		data: obj
	})
}
// 查询餐线
export function getMeal (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mac/meal/line/page',
		method: 'post',
		data: obj
	})
}
// 删除餐线
export function delMeal (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mac/meal/line/remove',
		method: 'delete',
		data: obj
	})
}
// 新增餐线
export function addMeal (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mac/meal/line/add',
		method: 'post',
		data: obj
	})
}
// 修改餐线
export function putMeal (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mac/meal/line/edit',
		method: 'post',
		data: obj
	})
}
// 餐线详情
export function getMealdetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mac/meal/line/list/mac',
		method: 'post',
		data: obj
	})
}
// 查询设备日志
export const getDeviceLogs = data => {
	return request({
		url: '/api/v2/devicelog/querylog',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 查询设备
export function getShebei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/getMachineByPage',
		method: 'get',
		params: obj
	})
}
// 查询设备-new
export function getDevice (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/device/page',
		method: 'get',
		params: obj
	})
}
// 新增设备-new
export function addDevice (data) {
	return request({
		url: '/api/v2/device/insert',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 更新设备-new
export function updateDevice (data) {
	return request({
		url: '/api/v2/device/update',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 删除设备-new
export function deleteDevice (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/device/delete',
		method: 'post',
		data: obj
	})
}
// 获取设备实时更新状态-new
export function getTcpState (data) {
	return request({
		url: '/api/v2/device/tcp/state',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 获取打印机状态-new
export function getPrintDeviceState (data) {
	return request({
		url: '/api/v2/print/get/status',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 根据场景获取打印机模板集合
export function getPrintTemplateListApi (data) {
	return request({
		url: '/api/v2/print/template/scene/template/list',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 根据场景获取打印机模板集合
export function getPrintTemplateConfigApi (data, noLoading) {
	return request({
		url: '/api/v2/print/template/column/group/list',
		method: 'post',
		noLoading: !!noLoading,
		data: { ...dataObj, content: data || {} }
	})
}
// 根据场景获取打印机模板集合
export function getPrintTemplateDetailApi (data, noLoading) {
	return request({
		url: '/api/v2/print/template/detail',
		method: 'post',
		noLoading: !!noLoading,
		data: { ...dataObj, content: data || {} }
	})
}
// 新增打印模板
export function addPrintTemplateApi (data) {
	return request({
		url: '/api/v2/print/template/add',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 修改打印模板
export function updatePrintTemplateApi (data) {
	return request({
		url: '/api/v2/print/template/update',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 修改打印模板
export function deletePrintTemplateApi (data) {
	return request({
		url: '/api/v2/print/template/delete',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 分页查询打印记录
export function pagePrintRecordApi (data) {
	return request({
		url: '/api/v2/print/record/page',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 查询设备新消费机
export function getShebeiXiaofeiji (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/getMachineTypeByPage',
		method: 'get',
		params: obj
	})
}
// 查询新版本设备
export function getShebeiNew (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/getMachineTypeByPage',
		method: 'get',
		params: obj
	})
}
// 添加新设备
export function addShebei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/postMachine',
		method: 'post',
		data: obj
	})
}
// 更新设备
export function putShebei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/putMachins',
		method: 'put',
		data: obj
	})
}

// 删除打印机
export function delPrinter (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/delPrinter',
		method: 'delete',
		data: obj
	})
}
// 删除设备
export function delShebei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/delMachine',
		method: 'delete',
		data: obj
	})
}
// 取餐柜详情
export function getShebeiDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/macmealscounter/detail/list/${data.machineId}`,
		method: 'get',
		params: obj
	})
}
// 获取指定食堂的首页推荐菜品列表
export function getDishes (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/index/recommend/dishes/list',
		method: 'post',
		data: obj
	})
}
// 设置小程序首页推荐菜品
export function addDishesindex (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/deploy/index/recommend',
		method: 'post',
		data: obj
	})
}
// 获取小程序配置的食堂下菜品列表
export function getDisheslabel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/canteen/dishes/list',
		method: 'post',
		data: obj
	})
}

// 查询系统卡信息
export function getcardsysinfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basecard/getBaseInfo',
		method: 'get',
		params: obj
	})
}

// 跟新系统卡信息
export function insertupcardsysinfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basecard/insertUpBaseInfo',
		method: 'post',
		data: obj
	})
}
// 添加设备扣款配置
export function addkoukuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/custdeduction/update/sn/deduction',
		method: 'post',
		data: obj
	})
}
// 获取设备扣款配置
export function getShebeiKoukuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/custdeduction/selectSnDeduction',
		method: 'post',
		data: obj
	})
}

// 下发菜谱
export function sendCaipu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/tcp/v1/menudishes/issue/recipe',
		method: 'post',
		data: obj
	})
}

// 下发所有菜谱
export function sendAllcaipu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/tcp/v1/menudishes/issue/all/recipe',
		method: 'post',
		data: obj
	})
}

// 下发部分菜谱
export function sendPartcaipu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/tcp/v1/menudishes/issue/part/recipe',
		method: 'post',
		data: obj
	})
}

// 扣款配置--获取全部扣款顺序
export function getallkoukuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/deduction/selectDeducTypeInEnum',
		method: 'get',
		params: obj
	})
}
// 扣款配置--获取个人扣款顺序信息
export function getcustkoukuanway (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/custdeduction/selectDeduction',
		method: 'post',
		data: obj
	})
}

// 扣款配置--获取扣款顺序信息
export function getkoukuanway (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/deduction/selectDeduction?',
		method: 'get',
		params: obj
	})
}

// 扣款配置--批量更新扣款顺序信息
export function updatekoukuanPiliang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}

	return request({
		url: '/api/v1/custdeduction/batchDeduction',
		method: 'put',
		data: obj
	})
}

// 扣款配置--更新扣款顺序信息
export function updatekoukuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}

	return request({
		url: '/api/v1/deduction/UpdateDeduction',
		method: 'post',
		data: obj
	})
}

// 设备绑定(特殊)
export function specialMchbind (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/smk/getPosList',
		method: 'post',
		data: obj
	})
}

// 设备绑定绑定按钮
export function putSpecialmchbind (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/smk/applyCert',
		method: 'post',
		data: obj
	})
}

// 食堂管理负责人接口
export function getcanteencust (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/list/by/role',
		method: 'post',
		data: obj
	})
}

// 信息发布屏
export function updatecolorformation (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/updateMacIssue',
		method: 'put',
		data: obj
	})
}

// 农行查询接口
export function getNonghang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/abc/config/merchant',
		method: 'get',
		params: obj
	})
}

// 农行更新接口
export function postNonghang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/abc/config/merchant',
		method: 'post',
		data: obj
	})
}

// 分页查询餐具信息
export function getTableware (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: 'api/v1/tableware/page/info',
		method: 'post',
		data: obj
	})
}

// 餐具id解析
export function getCanjuid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: 'api/v1/tableware/parse/code',
		method: 'get',
		params: obj
	})
}

// 新增餐具信息
export function addtableware (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: 'api/v1/tableware/info',
		method: 'post',
		data: obj
	})
}

// 修改餐具信息
export function updatetableware (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: 'api/v1/tableware/info',
		method: 'put',
		data: obj
	})
}

// 删除餐具信息
export function deletetableware (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: 'api/v1/tableware/info',
		method: 'delete',
		data: obj
	})
}

// 分页获取数据大屏权限
export function getDatahunterauthority (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ds/authority/list',
		method: 'post',
		data: obj
	})
}

// 新增权限
export function addDatahunterauthority (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ds/authority/add',
		method: 'post',
		data: obj
	})
}

// 修改权限
export function editDatahunterauthority (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ds/authority/edit',
		method: 'post',
		data: obj
	})
}

// 删除权限
export function delDatahunterauthority (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/ds/authority/remove/${data.authorityId}`,
		method: 'post',
		data: obj
	})
}

// 分页获取菜品识别服务配置
export function getMenuaiconfig (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics/menuai/config/page',
		method: 'post',
		data: obj
	})
}

// 新增菜品识别服务配置
export function addMenuaiconfig (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics/menuai/config/save',
		method: 'post',
		data: obj,
		encryption: ['noticePhone']
	})
}

// 修改菜品识别服务配置
export function editMenuaiconfig (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics/menuai/config/edit',
		method: 'post',
		data: obj,
		encryption: ['noticePhone']
	})
}

// 删除菜品识别服务配置
export function delMenuaiconfig (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/basics/menuai/config/remove/${data.menuaiId}`,
		method: 'post',
		data: obj
	})
}

// 切换菜品
export function changeCaipin (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/tcp/v1/machine/bindmenu',
		method: 'post',
		data: obj
	})
}

// 获取指定菜谱的全部菜品信息列表
export function getmenurecipe (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menurecipe/dishes/list',
		method: 'post',
		data: obj
	})
}

// 上传空托盘
export function uploadEmptyplate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/upload/empty/tray',
		method: 'post',
		data
	})
}

// 分页查询空托盘
export function getEmptyplate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/page/empty/tray',
		method: 'post',
		data: obj
	})
}

// 删除空托盘
export function delEmptyplate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/delete/empty/tray',
		method: 'post',
		data: obj
	})
}

// 重新加载字典
export function getZidian (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/tableware/reload/dict',
		method: 'post',
		data: obj
	})
}
// 批量注册人员
export function creatPerson (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/face/createPerson',
		method: 'post',
		data: obj
	})
}

// 校准时间
export function timeShebei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/face/setTime',
		method: 'post',
		data: obj
	})
}

// 设备激活
export function activeShebei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/shouqianbaActivate',
		method: 'post',
		data: obj
	})
}

// 获取工行配置
export function getGonghang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/icbc/config/merchant',
		method: 'get',
		params: obj
	})
}

// 更新工行配置
export function updateGonghang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/icbc/config/merchant',
		method: 'post',
		data: obj
	})
}
// 小程序功能列表分页
export function getIconList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basicsappleticon/page',
		method: 'post',
		data: obj
	})
}
// 小程序功能初始化
export function initIcon (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basicsappleticon/init',
		method: 'post',
		data: obj
	})
}
// 小程序功能编辑
export function editIcon (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basicsappleticon/edit/state',
		method: 'post',
		data: obj
	})
}
// 计量主机餐盘绑盘
export function jlzjBindplate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/android/macpaltebindserial/bindplateserial',
		method: 'post',
		data: obj
	})
}
// 获取钉钉配置信息
export function getDingding (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/dd/config/list',
		method: 'post',
		data: obj
	})
}
// 新增钉钉配置信息
export function addDingding (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/dd/config/add',
		method: 'post',
		data: obj
	})
}
// 编辑钉钉配置信息
export function editDingding (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/dd/config/edit',
		method: 'post',
		data: obj
	})
}
// 删除钉钉配置信息
export function delDingding (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/dd/remove/${data.id}`,
		method: 'post',
		data: obj
	})
}
// 开通钉工牌身份码
export function useDingdingIdentity (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/dd/openddsettings',
		method: 'post',
		data: obj
	})
}
// 后台-查询注册信息集合接口
export function getRegistInfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/page/regist/info',
		method: 'post',
		data: obj
	})
}

// 后台-获取食堂档口菜谱菜品拍照数量
export function getRegistDishesNum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/list/yunshitang/menuai/all/dishes/num',
		method: 'post',
		data: obj
	})
}
// 获取仓库
export function getCangku (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkteffective/warehouse/tenant/list',
		method: 'get',
		params: obj
	})
}
// 数据迁移
export function dataMoveServer (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/transfer/data',
		method: 'post',
		data: obj
	})
}
// 测试链接
export function testLinkApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics/menuai/config/test/connection',
		method: 'post',
		data: obj
	})
}

// 分页获取数据同步记录
export function getDSrecord (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/page/sync/record',
		method: 'post',
		data: obj
	})
}
// 重新裁剪大图接口
export function getTailorPhoto (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/cut/big/picture',
		method: 'post',
		data: obj
	})
}
export function goPrecheck (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/alipay/withhold/merApplyCheck',
		method: 'post',
		data: obj
	})
}
// 查询支付宝商户信息
export function goMerchantLnformation (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/alipay/withhold/queryMerInfo',
		method: 'post',
		data: obj
	})
}
// 商户申请状态
export function goMerchantApplication (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/alipay/withhold/queryMerApplyState',
		method: 'post',
		data: obj
	})
}
// 提交
export function getPaymentWithhold (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/alipay/withhold/merApply',
		method: 'post',
		data: obj
	})
}
// 后台-分页获取该食堂档口全量菜品菜品图片数量
export function getCaipuInfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/page/dishes/pic/num',
		method: 'post',
		data: obj
	})
}
// 获取菜单系统
export const getGlobalSystems = () => {
	return request({
		url: '/api/v1/mgrmenu/web/type',
		method: 'post',
		data: { ...dataObj }
	})
}
// 菜单列表
export function getMgrmenu (data) {
	return request({
		// url: '/api/v1/mgrmenu/table/tree',
		// method: 'get',
		// params: obj.content
		url: '/api/v1/mgrmenu/table/tree',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 新增菜单
export function addMgrmenu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrmenu/add',
		method: 'post',
		data: obj
	})
}
// 更新菜单
export function updateMgrmenu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrmenu/update',
		method: 'post',
		data: obj
	})
}
// 删除菜单
export function delMgrmenu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/mgrmenu/${data.menuId}`,
		method: 'delete',
		data: obj
	})
}
// 获取商户审核树
export function getSystemMenuTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrmenu/all/system/tree',
		method: 'post',
		// params: obj
		data: obj
	})
}
// 获取角色菜单树
export function getRoleTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgrmenu/tenant/tree',
		method: 'get',
		params: obj
	})
}

// 修改商家权限
export const getAllMenu = data => {
	return request({
		url: `/api/v1/mgrmenu/getAllMenu/${data.tenantId}`,
		method: 'get',
		params: { ...dataObj, content: data || undefined }
	})
}

// 新增标签
export function labelAdd (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data.labelName
	}
	return request({
		url: '/api/v2/alloc/label/add',
		method: 'post',
		data: obj
	})
}
// 编辑标签
export function labelUpdata (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/alloc/label/update',
		method: 'post',
		data: obj
	})
}
// 删除标签
export function labelRemove (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data.labelName
	}
	return request({
		url: '/api/v2/alloc/label/remove',
		method: 'post',
		data: obj
	})
}
// 分页查询标签
export function labelPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/alloc/label/page',
		method: 'post',
		data: obj
	})
}
/**
 * 分页查询食堂列表（新）
 */
export function pageCanteenListApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/alloc/canteen/page-canteen',
		method: 'post',
		data: obj
	})
}
// 获取页面装修位置信息
export function getMyDecoration (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/mobile/pagedecoration/list',
		method: 'post',
		data: obj
	})
}
// 更新适用页面位置信息
export function updateMyDecoration (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/mobile/pagedecoration/update',
		method: 'post',
		data: obj
	})
}
// 网关新增
export const addChupinjiwg = data => {
	return request({
		url: '/api/v1/machine/sub/save-or-edit',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
		// mock: true
	})
}
// 网关删除
export const delChupinjiwg = data => {
	return request({
		url: '/api/v1/machine/sub/delete-sub-machine',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
		// mock: true
	})
}
// 分页获取网关
export const getChupinjiwg = data => {
	return request({
		url: '/api/v1/machine/sub/query-sub-machine',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
		// mock: true
	})
}
// 后台重新下发菜品
export const xiafaDishesBywg = data => {
	return request({
		url: '/api/v1/machine/sub/re-issue-dishes',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
		// mock: true
	})
}
// 分页获取注册记录
export function getFaceRegist (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/face/page/regist',
		method: 'post',
		data: obj
	})
}
// 查询小程序基础设置
export function getMobileMetaData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mobile/metadata/query-base',
		method: 'post',
		data: obj
	})
}
// 保存小程序基础设置
export function updateMobileMetaData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mobile/metadata/save-base',
		method: 'post',
		data: obj
	})
}
// 查询平台设置
export function getPlatSet (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mobile/metadata/query-platform',
		method: 'post',
		data: obj
	})
}
// 保存平台设置
export function savePlatSet (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mobile/metadata/save-platform',
		method: 'post',
		data: obj
	})
}
// 保存平台设置
export function saveWorkWx (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/work/wx/sync/all/workWx',
		method: 'get',
		params: obj
	})
}
// 数据大屏开关查询, 修改
export function getDatascreenstate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/datascreen/metadata/query',
		method: 'post',
		data: obj
	})
}
export function saveDatascreenstate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/datascreen/metadata/save',
		method: 'post',
		data: obj
	})
}
// 人脸算法控制器
export const getFace = data => {
	return request({
		url: '/api/v2/face/metadata/query',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const saveFace = data => {
	return request({
		url: '/api/v2/face/metadata/save',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 获取学校pid/分库id
export const getGroupid = data => {
	return request({
		url: '/api/v1/applet/alipayopeniotvsp/getgroupid',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询统一回调地址域名
export const getUniformCallbackUrl = data => {
	return request({
		url: '/api/v2/alloc/metadata/queryUnifyPayNotifyHost',
		method: 'get',
		params: { ...dataObj, content: data || undefined }
	})
}

// 保存统一回调地址域名
export const saveUniformCallbackUrl = data => {
	return request({
		url: '/api/v2/alloc/metadata/saveUnifyPayNotifyHost',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 分页查询评价信息
export const getEvaluate = data => {
	return request({
		url: '/api/v1/canteen/evaluate/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 查询单条食堂评价详情
export const getEvaluateDetail = data => {
	return request({
		url: '/api/v1/canteen/evaluate/get-evaluate-detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询食堂评价评价配置左边总配置
export const getInitPageFirstAllConfigApi = data => {
	return request({
		url: '/api/v1/canteen/evaluate/query-init-page-first',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询食堂评价评价配置右边已经配置好的配置
export const getDecorationConfigOverApi = data => {
	return request({
		url: '/api/v1/canteen/evaluate/query-page-decoration',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 保存食堂评价配置
export const saveEvaluateApi = data => {
	return request({
		url: '/api/v1/canteen/evaluate/save-page-decoration',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 分页查询食堂评价统计
export const getEvaluateCount = data => {
	return request({
		url: '/api/v1/canteen/evaluate/page-evaluate-count',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 发布点赞菜品
export const issueDishes = data => {
	return request({
		url: '/api-v1/menu-like-dishes/issue',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 分页获取菜品点赞发布详情
export const getIssueDishes = data => {
	return request({
		url: '/api-v1/menu-like-dishes/date-page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 编辑指定日期发布菜品列表
export const editIssueDishes = data => {
	return request({
		url: '/api-v1/menu-like-dishes/date-edit',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 删除指定日期发布的点赞菜品
export const delIssueDishes = data => {
	return request({
		url: '/api-v1/menu-like-dishes/date-remove',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 分页获取菜品点赞汇总
export const getMenuLikeDishes = data => {
	return request({
		url: '/api-v1/menu-like-dishes/collect-page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 激活收钱吧
export const sqbActivative = data => {
	return request({
		url: '/api/v2/alloc/metadata/sqbActivation',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 客流统计折线图
export const queryPresentNum = data => {
	return request({
		url: '/api/v1/camera/queryPresentNum',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 客流统计折线图-表格
export const queryPresentTable = data => {
	return request({
		url: '/api/v1/camera/queryPassengerFlow',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 客流统计折线图-表格
export const additionalRecording = data => {
	return request({
		url: '/api/v1/camera/additional/recording',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
